import { useEffect } from 'react';

import { useAppSelector } from '@/hooks';
import { setTelemetryUser } from '@/services/application-insights';

import { AuthService } from '../services';
import { selectAuth } from '../store';
import { ClaimTypes } from '../typings';

/** Keeps the telemetry user on the signed-in provider's opaque UserID; renders nothing. */
export function TelemetryUserSync(): null {
  const { token } = useAppSelector(selectAuth);

  useEffect(() => {
    const userId = token
      ? new AuthService().getTokenClaims()[ClaimTypes.NameIdentifier]
      : undefined;
    setTelemetryUser(userId || null);
  }, [token]);

  return null;
}
